import BaseAPI from '../../base'
import { apis, getApiUrl } from '../api-config'
/**
 * API xử lý lớp học
 */
class ClassroomAPI extends BaseAPI {}

export default new ClassroomAPI('v1/classrooms', 'Classroom', getApiUrl(apis.StudentAPI))
